import { useEffect, useRef } from "react";
import axiosInstance from "../../shared/axiosInstance";
import { API } from "../../constants";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "../../msalInstance";
import { queryClient } from "../../api/queryClient";

const clearLocalStorage = () => {
  const isDevMode = localStorage.getItem("devMode") === "true";
  localStorage.clear();
  queryClient.clear(); // cached server data must not outlive the login

  if (isDevMode) {
    localStorage.setItem("devMode", "true");
  }
};

const Logout = () => {
  const navigate = useNavigate();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    async function logout() {
      if (hasLoggedOut.current) {
        return;
      }
      hasLoggedOut.current = true;

      const isEntraAuth = sessionStorage.getItem("entraLogin") === "true";

      try {
        await axiosInstance.post(`/${API.AUTH.LOGOUT}`);
        console.log("Backend logout successful");
      } catch (err) {
        console.error("Server session clear failed:", err);
      }

      if (isEntraAuth) {
        try {
          console.log("Performing Entra logout...");

          await msalInstance.initialize();
          const account = msalInstance.getActiveAccount();

          console.log("Active account:", account);

          if (account) {
            sessionStorage.clear();
            clearLocalStorage();

            await msalInstance.logoutRedirect({
              account: account,
              postLogoutRedirectUri: window.location.origin,
            });
          } else {
            console.log("No active account found, clearing cache");
            sessionStorage.clear();
            clearLocalStorage();
            msalInstance.clearCache();
            navigate("/", { replace: true });
          }
        } catch (err) {
          console.error("Entra logout failed:", err);
          sessionStorage.clear();
          clearLocalStorage();
          msalInstance.clearCache();
          navigate("/", { replace: true });
        }
      } else {
        console.log("Performing Cognito logout...");
        sessionStorage.clear();
        clearLocalStorage();
        navigate("/", { replace: true });
      }
    }

    logout();
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontSize: "1.2rem",
      }}
    >
      Logging out...
    </div>
  );
};

export default Logout;
